var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
function SvgLinkedin(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 46 46' }, props),
        React.createElement("path", { d: 'M45.988 46v-.002H46V29.154c0-8.24-1.787-14.587-11.49-14.587-4.666 0-7.796 2.541-9.074 4.95H25.3v-4.181h-9.2v30.662h9.58V30.815c0-3.997.764-7.863 5.75-7.863 4.914 0 4.988 4.562 4.988 8.12V46h9.57zM.767 15.333h9.2V46h-9.2zM5.367 0C2.404 0 0 2.564 0 5.723 0 8.883 2.404 11.5 5.367 11.5c2.962 0 5.366-2.617 5.366-5.777C10.731 2.563 8.327 0 5.367 0z' })));
}
export default SvgLinkedin;
//# sourceMappingURL=Linkedin.js.map